// extracted by mini-css-extract-plugin
module.exports = {"prod-ratings":"ProductCard_prod-ratings__1kKnC","card":"ProductCard_card__3-cAW","fav-btn":"ProductCard_fav-btn__3KE41"};